import { SupportedLocale } from '@/utils/i18n/supportedLocales';

/**
 * Locale key → BCP-47 folder mapping for translation imports.
 * Note: `en` uses @/locales/en/ as it is the source file (default locale).
 */
export const languageLoaders = {
  [SupportedLocale.ArSa]: () => import('@/locales/ar-SA/common.json'),
  [SupportedLocale.CaEs]: () => import('@/locales/ca-ES/common.json'),
  [SupportedLocale.DaDk]: () => import('@/locales/da-DK/common.json'),
  [SupportedLocale.DeDe]: () => import('@/locales/de-DE/common.json'),
  [SupportedLocale.En]: () => import('@/locales/en/common.json'),
  [SupportedLocale.EnPs]: () => import('@/locales/en/common.json'),
  [SupportedLocale.EsEs]: () => import('@/locales/es-ES/common.json'),
  [SupportedLocale.FiFi]: () => import('@/locales/fi-FI/common.json'),
  [SupportedLocale.FrFr]: () => import('@/locales/fr-FR/common.json'),
  [SupportedLocale.ItIt]: () => import('@/locales/it-IT/common.json'),
  [SupportedLocale.JaJp]: () => import('@/locales/ja-JP/common.json'),
  [SupportedLocale.KoKr]: () => import('@/locales/ko-KR/common.json'),
  [SupportedLocale.NlNl]: () => import('@/locales/nl-NL/common.json'),
  [SupportedLocale.NbNo]: () => import('@/locales/nb-NO/common.json'),
  [SupportedLocale.PlPl]: () => import('@/locales/pl-PL/common.json'),
  [SupportedLocale.PtPt]: () => import('@/locales/pt-PT/common.json'),
  [SupportedLocale.SvSe]: () => import('@/locales/sv-SE/common.json'),
  [SupportedLocale.ZhCn]: () => import('@/locales/zh-CN/common.json'),
  [SupportedLocale.ZhTw]: () => import('@/locales/zh-TW/common.json'),
};
